import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IMenuReq } from '../../../../models/menus.model'
import { doGetMenu, doUpdateMenu } from '../../../../store/menu.slice';
import { doRemoveAuth } from '../../../../store/auth.slice';
import { RootState } from '../../../../store/rootReducer';
import { useSnackbar } from 'notistack';

import Loader from '../../../../components/Loader';
import SimpleHeader from '../../../../components/layout/SimpleHeader';
import Footer from '../../../../components/layout/Footer';
import Editor from '../../../../components/system/menu/Editor';
import { errorVariant, successVariant, warningVariant } from '../../../../lib/barVariant';

interface IMatch {
  topId: string;
  subId: string;
}

const SystemMenuEdit: FC<RouteComponentProps> = ({ history }) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { menu, isLoading } = useSelector((state: RootState) => state.menu);
  
  const match = useRouteMatch<IMatch>();
  const topId = Number(match.params.topId);
  const subId = Number(match.params.subId);

  useEffect(() => {
    getMenu(subId);
  }, [])

  const getMenu = async (subId: number) => {
    const res = await dispatch(doGetMenu(subId));

    switch (res?.status) {
      case 200:
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  const onSubmit = async (req: IMenuReq) => {
    const res = await dispatch(doUpdateMenu(subId, req));
    
    switch (res?.status) {
      case 200:
        enqueueSnackbar(t('common.message.edit'), successVariant);
        history.push(`/system/menu/${topId}/submenu`);
        break;
      case 401:
        dispatch(doRemoveAuth());
        break;
      case 403:
        enqueueSnackbar(t('common.message.forbidden'), warningVariant);
        history.push('/');
        break;
      default:
        enqueueSnackbar(res?.data?.data || t('common.message.error'), errorVariant);
    }
  }

  return (
    <div className="content scrollbar">
      {isLoading ? <Loader /> : null}
      <SimpleHeader
        parentMenu={t('common.menu.system')}
        currentMenu={t('system.menu.title5')}
      />
      <Editor
        menu={menu || null}
        onSubmit={onSubmit}
        cancelPath={`/system/menu/${topId}/submenu`}
      />
      <Footer />
    </div>
  )
}

export default SystemMenuEdit;
